export const mainExtension = {
  initialize(naja) {
    naja.addEventListener('start', ({detail}) => {                      
      if(detail.options.spinner) {
        $("#"+detail.options.spinner).addClass("show");
      }
    });
    naja.addEventListener('success', ({detail}) => {      

    });
    naja.addEventListener('complete', ({detail}) => {

    });   
  }
}